<script>
export default {
  name: 'LimitedComponentsList',
  props: {
    items: { type: Array, default: () => [] },
    limit: { type: Number, default: 3 },
    allowWrap: { type: Boolean, default: false },
    component: { type: [Object, String] },
    componentFactory: { type: Function },
    componentProps: { type: Function, default: () => el => ({ item: el }) },
    mainClass: { type: String, default: '' },
    withWrapper: { type: Boolean, default: false },
    wrapperClass: { type: [Object, String, Array], default: () => [] },
  },
}
</script>

<template lang="pug">
div(v-if="withWrapper" :class="wrapperClass")
  div(
    v-for="(item, index) of (items || []).slice(0,limit)"
    :class="[mainClass, { 'text-nowrap': !allowWrap }]"
    :key="index"
  )
    template(v-if="componentFactory")
      component(v-bind="componentProps(item)" :is="componentFactory(item)")
    template(v-else)
      component(v-bind="componentProps(item)" :is="component")
  .text-black-50(v-if="(items || []).length > limit" :class="mainClass")
    .text-nowrap and {{ (items || []).length - limit }} more...
    .text-nowrap (click row details to see all)
  .text-black-15(v-else-if="!(items || []).length" :class="mainClass") empty
template(v-else)
  div(
    v-for="(item, index) of (items || []).slice(0,limit)"
    :class="[mainClass, { 'text-nowrap': !allowWrap }]"
    :key="index"
  )
    template(v-if="componentFactory")
      component(v-bind="componentProps(item)" :is="componentFactory(item)")
    template(v-else)
      component(v-bind="componentProps(item)" :is="component")
  .text-black-50(v-if="(items || []).length > limit" :class="mainClass")
    .text-nowrap and {{ (items || []).length - limit }} more...
    .text-nowrap (click row details to see all)
  .text-black-15(v-else-if="!(items || []).length" :class="mainClass") empty
</template>
